import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-checkbox-filter',
  templateUrl: './checkbox-filter.component.html',
  styleUrls: ['./checkbox-filter.component.scss']
})
export class CheckboxFilterComponent implements OnInit {

  @Input()
  idPrefix;

  @Input()
  options = [1, 111, 1, 1, 1, 1, 1];
  constructor() { }

  ngOnInit() {
  }

  onChecked(index: number, event) {
    console.log(index, event);
    console.log(event.target.checked);
  }

}
